export enum GasUnitValue {
    PPB = 0,
    PPM = 1,
}

export enum WindspeedUnitValue {
    MeterPerSecond = 0,
    MilesPerHour = 1,
    FeetPerSecond = 2,
    KmPerhour = 3,
    Knot = 4,
}

export enum RainfallUnitValue {
    MmPerHour = 0,
    InchPerHour = 1,
}

export enum FlowrateUnitValue {
    MlPerMinute = 0,
    LPerMinute = 1,
}

export enum MassUnitValue {
    Ug = 0,
    Mg = 1
}

export enum LengthUnitValue {
    Centimeter = 0,
    Foot = 1,
}

export enum AreaUnitValue {
    SquareCentimeter = 0,
    SquareFoot = 1,
}